import { usePostContentContext } from '@/postContentElement/context';

import { genericEmbedHostContainer, genericEmbedHostParagraph } from './GenericEmbedHost.css';
import type { TPostGenericEmbedHostProps } from './GenericEmbedHost.types';

export const PostGenericEmbedHost = ({ element }: TPostGenericEmbedHostProps) => {
  const { postTheme } = usePostContentContext();

  if (!element?.content?.[0]?.text || postTheme?.hyperlink_hide_link === 'true') {
    return null;
  }

  return (
    <div className={genericEmbedHostContainer}>
      <p className={genericEmbedHostParagraph}>{element.content[0].text}</p>
    </div>
  );
};
